export default [
  {
    path: "/bjzx",
    name: "bjzx",
    component: (resolve) => require(["@/views/PCView/bjzx/index.vue"], resolve),
  },
  {
    path: "/bjzxdetail",
    name: "bjzxdetail",
    component: (resolve) => require(["@/views/PCView/bjzx/BjzxDetail.vue"], resolve),
    // redirect: "/bjzxdetail/bjzxmain",
    // children: [
    //   {
    //     path: "/bjzxdetail/bjzxmain",
    //     name: "bjzxmain",
    //     component: (resolve) =>
    //       require(["@/views/PCView/bjzx/view/Main.vue"], resolve),
    //   },
    //   {
    //     path: "/bjzxdetail/bjzxblog",
    //     name: "bjzxblog",
    //     component: (resolve) =>
    //       require(["@/views/PCView/bjzx/view/Blog.vue"], resolve),
    //   },
    //   {
    //     path: "/bjzxdetail/bjzxwenxian",
    //     name: "bjzxwenxian",
    //     component: (resolve) =>
    //       require(["@/views/PCView/bjzx/view/Wenxian.vue"], resolve),
    //   },
    //   {
    //     path: "/bjzxdetail/bjvideo",
    //     name: "bjvideo",
    //     component: (resolve) =>
    //       require(["@/views/PCView/bjzx/view/BjVideo.vue"], resolve),
    //   },
    //   {
    //     path: "/bjzxdetail/bjmonograph",
    //     name: "bjmonograph",
    //     component: (resolve) =>
    //       require(["@/views/PCView/bjzx/view/BjMonograph.vue"], resolve),
    //   },
    // ],
  },
];
